
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  reactive,
  watch,
} from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "IndustrySectors",
  components: {},
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
    touchedParent: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const touched = ref<boolean>(false);
    watch(
      () => props.touchedParent,
      (value) => {
        touched.value = value;
        if (value && !selectedIndustrySectors.value?.length)
          isAnyIndustrySectorSelected.value = true;
      }
    );
    const isAnyIndustrySectorSelected = ref<boolean>(false);
    const industrySectors = computed(() => store.getters.industrySectorsGetter);
    let formData = ref<Record<string, unknown>>(props.formDataTemp);
    let selectedIndustrySectors = ref<Array<number>>([]);
    const checkedIndustrySectors = reactive<Record<string, boolean>>({});
    watch(() => props.formDataTemp, (value) => {
      formData.value = { ...value };
      const temp = [...((formData.value as {"industrySectors"})?.industrySectors ?? [])];
      selectedIndustrySectors.value = temp.length
        ? [...temp]
        : [...selectedIndustrySectors.value];
      for (
        let i = 0;
        i < ((formData.value as {"industrySectors"})?.industrySectors?.length ?? 0);
        i++
      ) {
        checkedIndustrySectors[(formData.value as {"industrySectors"})?.industrySectors[i]] = true;
      }
      emit("industrySectorsLength", selectedIndustrySectors.value.length);
    });
    watch(
      () => props.formDataTemp,
      () => {
        formData.value = props.formDataTemp;
      }
    );
    const fieldChanged = async () => {
      formData.value["industrySectors"] = selectedIndustrySectors.value;
      emit("form-data", formData.value);
      // try {
      //   const res = await store.dispatch(Actions.CREATE_BUSINESS_DRAFT, {
      //     business: JSON.stringify(formData.value),
      //   });
      //   if (res !== true) throw new Error("error in API");
      // } catch (err) {
      //   console.log({ err });
      // }
    };
    const addToIndustrySectors = (event) => {
      if (event.target.checked) {
        selectedIndustrySectors.value = [
          ...selectedIndustrySectors.value,
          event.target.dataset["id"],
        ];
      } else {
        selectedIndustrySectors.value = selectedIndustrySectors.value.filter(
          (i) => {
            return i != event.target.dataset["id"];
          }
        );
      }
      emit("industrySectorsLength", selectedIndustrySectors.value.length);
      isAnyIndustrySectorSelected.value = false
      fieldChanged();
    };
    onMounted(async () => {
      if (!industrySectors.value.length)
        await store.dispatch(Actions.GET_INDUSTRY_SECTORS);
    });
    return {
      formData,
      fieldChanged,
      industrySectors,
      addToIndustrySectors,
      selectedIndustrySectors,
      checkedIndustrySectors,
      isAnyIndustrySectorSelected,
    };
  },
});
